"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("./constant");
var _default = {
  PropTypes: {
    headerLabel: _propTypes.string.isRequired,
    data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      icon: _propTypes.string,
      text: _propTypes.string.isRequired,
      value: _propTypes.any.isRequired,
      showArrow: _propTypes.bool
    })).isRequired,
    headerIcon: _propTypes.string,
    headerConfig: (0, _propTypes.shape)({
      normalColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
      hoverColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
      activeColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
      textSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
      iconSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE)
    }),
    hasDropDownActionIcon: _propTypes.bool,
    dropDownActionIconConfig: (0, _propTypes.shape)({
      open: _propTypes.string,
      close: _propTypes.string
    }),
    defaultOpenDropdown: _propTypes.bool,
    defaultSelectedData: _propTypes.any,
    dataConfig: (0, _propTypes.shape)({
      textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
      textSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
      iconSize: (0, _propTypes.oneOf)(_constant.ARR_FONT_SIZE),
      backgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS),
      hoverBackgroundColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS)
    }),
    onOptionSelect: _propTypes.func,
    dropdownPosition: (0, _propTypes.oneOf)(Object.values(_constant2.DROPDOWN_POSITIONS)),
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    optionsCustomProperties: _propTypes.object,
    customProperties: _propTypes.object,
    fireGtm: _propTypes.func,
    dropdownIconColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    dropdownIconGap: _propTypes.string,
    hasSelectedCheckIcon: _propTypes.bool,
    hasBottomLine: _propTypes.bool
  },
  DefaultProps: {
    defaultOpenDropdown: false,
    headerConfig: {
      normalColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.HEADER_CONFIG.NORMAL_COLOR,
      hoverColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.HEADER_CONFIG.HOVER_COLOR,
      activeColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.HEADER_CONFIG.ACTIVE_COLOR,
      textSize: _constant2.DROPDOWN_OPTIONS_DEFAULTS.HEADER_CONFIG.TEXT_SIZE,
      iconSize: _constant2.DROPDOWN_OPTIONS_DEFAULTS.HEADER_CONFIG.ICON_SIZE
    },
    hasDropDownActionIcon: true,
    dropDownActionIconConfig: {
      open: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DROPDOWN_ICON.OPEN,
      close: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DROPDOWN_ICON.CLOSE
    },
    dataConfig: {
      textColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DATA_CONFIG.TEXT_COLOR,
      textSize: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DATA_CONFIG.TEXT_SIZE,
      iconSize: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DATA_CONFIG.ICON_SIZE,
      backgroundColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DATA_CONFIG.BACKGROUND_COLOR,
      hoverBackgroundColor: _constant2.DROPDOWN_OPTIONS_DEFAULTS.DATA_CONFIG.HOVER_BG_COLOR
    },
    dropdownPosition: _constant2.DROPDOWN_OPTIONS_DEFAULTS.POSITION,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    dropdownIconGap: '16px',
    hasSelectedCheckIcon: false,
    hasBottomLine: true
  }
};
exports.default = _default;